import $ from 'jquery';

function openShare(e) {
  e.stopPropagation();
  const $targetShareWidget = $(e.target).closest('.article-meta-wrap');
  const $otherShareWidgets = $('.article-meta-wrap').not($targetShareWidget);

  $targetShareWidget.addClass('active');
  $otherShareWidgets.removeClass('active');
}

function closeShare(e) {
  if (!$(e.target).closest('.share-widget-toggle').length && !$(e.target).closest('.share-widget').length) {
    $('.article-meta-wrap').removeClass('active');
  }
}

export default class Share {
  constructor({ el }) {
    this.$el = $(el);
    if (this.$el.find('.article-meta-wrap')) {
      $(document.body).on('click', e => closeShare(e));
      $('.share-widget-toggle', this.$el).on('click', e => openShare(e));
    }
  }
}
